/**
 * Utility to detect and manage Invoca test mode based on query parameters
 */

/**
 * Check if Invoca test mode is enabled via query string
 * @returns {boolean} True if invoca_rev=draft is present in the URL
 */
export const isInvocaTestMode = () => {
  if (typeof window === 'undefined') {
    return false;
  }

  return sessionStorage.getItem('invocaTestMode') === 'true';
};

/**
 * Ensure the invoca_rev=draft parameter is present in the URL
 * Uses replaceState to avoid adding to browser history
 */
export const ensureInvocaTestModeParam = () => {
  if (typeof window === 'undefined') {
    return;
  }

  const url = new URL(window.location);
  if (!url.searchParams.has('invoca_rev')) {
    url.searchParams.set('invoca_rev', 'draft');
    window.history.replaceState(null, '', url.toString());
  }
};

/**
 * Append invoca_rev=draft to a URL if test mode is active
 * @param {string} url - The URL to modify
 * @returns {string} The modified URL
 */
export const appendInvocaTestModeParam = (url) => {
  if (!isInvocaTestMode()) {
    return url;
  }

  try {
    // Handle relative URLs by creating a dummy base if needed
    const isRelative = !url.startsWith('http');
    const dummyBase = 'http://dummy.com';
    const urlObj = new URL(url, isRelative ? dummyBase : undefined);

    if (!urlObj.searchParams.has('invoca_rev')) {
      urlObj.searchParams.set('invoca_rev', 'draft');
    }

    const finalUrl = isRelative
      ? urlObj.pathname + urlObj.search + urlObj.hash
      : urlObj.toString();
    return finalUrl;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('Error appending Invoca param:', e);
    return url;
  }
};
